module.exports = __webpack_public_path__ + "assets/img/02.2624e513.png";